enum ClientPremission {
  Prem_Clients_Main = 'Prem_Clients_Main',
  Prem_Clients_Main_Edit = 'Prem_Clients_Main_Edit',
  Prem_Clients_Acc = 'Prem_Clients_Acc',
  Prem_Clients_Acc_Edit = 'Prem_Clients_Acc_Edit',
  Prem_Clients_Statistics = 'Prem_Clients_Statistics',
  Prem_Clients_Purchases = 'Prem_Clients_Purchases',
  Prem_Clients_Purchases_Edit = 'Prem_Clients_Purchases_Edit',
  Prem_Clients_Client_Store_Open = 'Prem_Clients_Client_Store_Open',
  Prem_Clients_Client_Store_Add = 'Prem_Clients_Client_Store_Add',
  Prem_Clients_Client_Store_Remove = 'Prem_Clients_Client_Store_Remove',
  Prem_Clients_Location_Open = 'Prem_Clients_Location_Open',
  Prem_Clients_Location_Edit = 'Prem_Clients_Location_Edit',
  Prem_Clients_Edits = 'Prem_Clients_Edits',
  Prem_Clients_Add_Loacation = 'Prem_Clients_Add_Loacation',
  Prem_Clients_License_Add = 'Prem_Clients_License_Add',
  Prem_Clients_License_Remove = 'Prem_Clients_License_Remove',
  Prem_Clients_License_Review = 'Prem_Clients_License_Review',
  Prem_Clients_License_Approve = 'Prem_Clients_License_Approve',
  Prem_Clients_Balances_List = 'Prem_Clients_Balances_List',
  Prem_Clients_TrustLimit_Update = 'Prem_Clients_TrustLimit_Update',
  Prem_Clients_Show_Disabled = 'Prem_Clients_Show_Disabled',
}

export default ClientPremission;
